import type { OpenSeaOfferRef } from "@anaconda/core/bid/types"
import type { NftMiniature } from "@anaconda/core/nft/types"
import type { Blockchain } from "@rarible_int/anaconda_sdk/ethereum"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { EvmAcceptOpenSeaOfferMoleculeReatom } from "./evm-accept-opensea-offer-molecule.reatom"

interface EvmAcceptOpenSeaOfferParams {
  nft: NftMiniature
  offer: OpenSeaOfferRef
}

export function useEvmAcceptOpenSeaOffer(blockchain: Blockchain) {
  const { acceptOpenSeaOfferActionFactory } = useMolecule(
    EvmAcceptOpenSeaOfferMoleculeReatom,
  )
  const acceptAction = useMemo(
    () => acceptOpenSeaOfferActionFactory(),
    [acceptOpenSeaOfferActionFactory],
  )

  const onSuccess = useCallback(
    (params: EvmAcceptOpenSeaOfferParams) => {
      acceptAction({ ...params, blockchain }).catch(() => undefined)
    },
    [acceptAction, blockchain],
  )

  const { action, switchInProgress } =
    useSwitchEvmChain<EvmAcceptOpenSeaOfferParams>(blockchain, onSuccess)

  return {
    mutate: action,
    isPending: !!acceptAction.pending() || switchInProgress,
  }
}
